// extracted by mini-css-extract-plugin
export default {"navbar":"Innavbar_navbar__W9xel","logo":"Innavbar_logo__3dx5I","links":"Innavbar_links__oXBIz","link":"Innavbar_link__jMdjd"};